import { render } from "./choiceYear.vue?vue&type=template&id=50dae195&scoped=true"
import script from "./choiceYear.vue?vue&type=script&lang=js"
export * from "./choiceYear.vue?vue&type=script&lang=js"

import "./choiceYear.vue?vue&type=style&index=0&id=50dae195&scoped=true&lang=css"

import exportComponent from "/var/jenkins_home/workspace/edu2-web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-50dae195"]])

export default __exports__